import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFFILIATE_PROGRAM_COMMISSIONS = Symbol('affiliate-program.commissions');

export const AFFILIATE_PROGRAM_COMMISSIONS_ROUTE_NAME = Symbol('affiliate-program.commissions');
export const AFFILIATE_PROGRAM_COMMISSIONS_LIST_ROUTE_NAME = Symbol('affiliate-program.commissions.list');

export const AFFILIATE_PROGRAM_COMMISSIONS_LIST_API_URL = 'admin/conditions/list';
export const AFFILIATE_PROGRAM_COMMISSIONS_LIST_QUERY_KEY = 'affiliate-program.commissions.list';

export const AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.CONDITIONS_SHOW),
  EDIT: new Permission(PermissionsList.admin.CONDITIONS_EDIT),
  DELETE: new Permission(PermissionsList.admin.CONDITIONS_DELETE),
};
